import { useState } from "react";
import { exportMPDashboardCsv } from "../api/exportMPDashboardCsv/exportMPDashboardCsvApi";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadMPDashboardCsv() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadCsv = async (intacctId: string) => {
    setLoading(true);
    setError(null);
    try {
      const blob = await exportMPDashboardCsv(intacctId);
      const timestamp = new Date().toISOString().split("T")[0];
      const fileName = `market-presence-${timestamp}.csv`;
      downloadFile(blob, fileName);
    } catch (err: unknown) {
      if (err instanceof Error) {
        console.error("MP Dashboard CSV download error:", err.message);
        setError(err.message);
      } else {
        setError("Failed to download Market Presence CSV");
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    downloadCsv,
    error,
  };
}